import axios from "axios";
import {
  Toast
} from 'vant';
import {
  jsSdk
} from './api'
// export const HERF = 'http://keyiche.anagelink.cn'
// export const SOHERF = 'wss://keyiche.anagelink.cn:9202'

// 线上
export const HERF = 'http://h5.keyice.club'
export const SOHERF = 'wss://h5.keyice.club:9202'
export const DEFAULTAPPID = 'wx47e921a6c75be7e1'

export const qywx = 'https://work.weixin.qq.com/kfid/kfcac29e1dbda64c7a1'

// import {
//   resolve
// } from "core-js/fn/promise";
const imageCoversion = require("image-conversion");
//上传图片
export function uploadimg(file) {
  const api_token = localStorage.getItem("token");
  const formdata = new FormData();
  console.log(file.file.type, 'type');
  const isJpgOrPng = file.file.type === 'image/jpeg' || file.file.type === 'image/png';
  if (!isJpgOrPng) {
    Toast('上传图片只能是JPG或PNG 格式!');
    return false;
  }
  formdata.append('api_token', api_token)
  return new Promise((resolve, reject) => {
    imageCoversion
      .compressAccurately(file.file, 300)
      .then((res1) => {
        console.log(file.file, '-----------file.file');
        console.log(res1, '-----------res1');
        formdata.append('file', res1)

        let config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
        // return new Promise((resolve, reject) => {
        axios.post("/api/uploadImg", formdata, config).then(res => {
          console.log(res.data);
          if (res.data.code == 0) {
            resolve(res.data.data)
          } else {
            Toast(res.data.message)
            resolve(false)
          }
        }).catch(err => {
          Toast(err)
          reject(err)
        })
        // })
      })
      .catch((res) => {
        console.log(res);
        Toast("上传失败，请稍后重试");
      });
  })
}


export function formatRichText(html) { //控制小程序中图片大小
  if (!html) return '';
  // let newContent = html.replace(/<img[^>]*>/gi, function (match) {
  //   match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
  //   match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
  //   match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
  //   return match;
  // });
  // newContent = newContent.replace(/style="[^"]+"/gi, function (match) {
  //   match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
  //   return match;
  // });

  // newContent = newContent.replace(/<br[^>]*\/>/gi, '');
  // newContent = newContent.replace(/<img/gi,
  //   '<img style="max-width:100%;height:auto;display:inline-block;margin:10rpx auto;"');
  return html.replace(/\<img/gi, '<img style="width:100%;height:auto" ');
  // return newContent;
}



export function getCode() {
  let usercode = getQueryString('usercode');
  if (usercode) {
    sessionStorage.setItem('userCode', usercode);
    // window.location.href = HERF + '/h5/#/sq'
  }
}

export function getQueryString(variable) {
  let herf = window.location.href;
  let num = herf.lastIndexOf("?") + 1;
  let query = herf.substring(num);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}

// 分享配置
import wx from "jweixin-module";
export function shareJsSdk(shareUrl, shareTitle = '', shareDesc = '', detailId = '', shareImg = '', usercode = '') {
  //detailId  --详情需要传Id  
  const u = navigator.userAgent;
  let that = this;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  let url = "";
  if (isiOS) {
    url = window.location.href.split("#")[0];
    // url = window.location.href;
  } else {
    url = window.location.href;
  }
  console.log(url, '------------====================');
  setTimeout(() => {
    jsSdk({
      url
    }).then((res) => {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.signature, // 必填，签名
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
      });
      let user = localStorage.getItem("user");
      if (user) {
        user = JSON.parse(user);
      } else {
        user = "";
      }
      let u = "#" + window.location.href.split("#")[1];
      if (detailId) {
        u = HERF + `/h5/?appid=${getAppid() ? getAppid(): DEFAULTAPPID}#/` + shareUrl + "?id=" + detailId + "&share=1";
      } else {
        u = HERF + `/h5/?appid=${getAppid() ? getAppid(): DEFAULTAPPID}#/` + shareUrl + "?share=1";
      }
      if (usercode) {
        u = u + '&usercode=' + usercode
      }
      console.log(u, "-----------shareurl----------");
      let title = shareTitle ? shareTitle : "";
      let desc = shareDesc ? shareDesc : "优质推荐 您的好友强烈推荐您查看，点击查看。";
      wx.ready(function () {
        var imgUrl = shareImg ? shareImg : HERF + "/backstage/kycx.png";
        //分享给朋友
        wx.updateAppMessageShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: u, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: function () {},// 用户确认分享后执行的回调函数
          cancel: function () {},// 用户取消分享后执行的回调函数
        });
        wx.updateTimelineShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: u, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: function () {},// 用户确认分享后执行的回调函数
          cancel: function () {},// 用户取消分享后执行的回调函数
        });
        wx.error((res) => {
          console.log(res);
        });
        // TODO
      });
    });
  }, 500);
}

export function getAppid() {
  let herf = window.location.href;
  if (herf.indexOf("?appid=") >= 0) {
    let num = herf.indexOf("?appid=") + 7;
    let appid = herf.substring(num);
    appid = appid ? appid.substring(0, appid.indexOf('#/')) : '';
    if (appid.indexOf('&') >= 0) {
      appid = appid.substring(0, appid.indexOf('&'))
    }
    return appid;
  }else{
    return false;
  }

}

export function $formatDates(date){
  var date = new Date(date);
		var YY = date.getFullYear() + '/';
		var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
		var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
		return YY + MM + DD;
}